<script setup lang="ts">
// 汎用FormInput

interface Props {
  modelValue?: string;
  label?: string;
  label2?: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  id?: string;
  alert?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  label: "テキスト",
  label2: "",
  alert: "値を入力してください",
  placeholder: "テキストを入力",
  require: false,
  type: "text",
});

const emit = defineEmits<{
  "update:modelValue": [modelValue: string];
}>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const isError = ref(false);

function validate() {
  // 必須で値がない
  if (props.required && !props.modelValue) {
    isError.value = true;
    return false;
  }
  // 必須でない || 必須で値がある
  isError.value = false;
  return true;
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el" class="w-full tablet:max-w-[50%] relative pb-6">
    <FormInputLabel :id="id" :label="label" :label2="label2" />
    <MInput
      :id="id"
      v-model="localValue"
      class="w-full block rounded p-2"
      :type="type"
      :placeholder="placeholder"
      :color="isError ? 'error' : 'normal'"
    />

    <FormAlert
      v-if="isError"
      type="error"
      class="flex items-center absolute bottom-0"
    >
      <Icon class="mr-1 text-sm" size="18" name="mdi:alert-circle" />
      <span>{{ alert }}</span>
    </FormAlert>
  </div>
</template>
